import { atom } from 'recoil';
import { IAnalisePerfil } from '../../commons/types/analisePerfil';


export const analisePerfisAtom = atom<IAnalisePerfil[]>({
  key: 'analisePerfis', 
  default: [] as IAnalisePerfil[],
}); 
